import { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";
import mergeCssClasses from "utils/mergeCssClasses";
import { useAuthContext } from "context/AuthContext";
import { useDocTypeContext } from "context/DocTypeContext";
import Paths from "router/Paths";

import { AngleDownSvg } from "svg/icons";
import navigation from "./navigation";
import "./sidebar.scss";

export default function Sidebar({ open, toggleSidebar, showProfile }: {
   open: boolean;
   toggleSidebar: () => void;
   showProfile: () => void;
}) {

   const { user, logOut } = useAuthContext();
   const { doc_types } = useDocTypeContext();
   
   const [ open_submenu, setOpenSubmenu ] = useState( false );

   return (
      <div className={ mergeCssClasses( "sidebar", open && "open" )}>
         <div className="sidebar-body">
            <div className="sidebar-nav-box">

               <div className="sidebar-body-toggler">
                  <div/>
                  <button onClick={() => toggleSidebar()}>
                     <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 40C8.95373 40 0 31.0463 0 20C0 8.95503 8.95373 -3.8147e-06 20 -3.8147e-06C31.0463 -3.8147e-06 40 8.95503 40 20C40 31.0463 31.0463 40 20 40ZM28.75 18.75H15.5175L20.6687 13.5988C21.1575 13.11 21.1575 12.3188 20.6687 11.8313C20.1799 11.3425 19.3888 11.3425 18.9012 11.8313L11.83 18.9025C11.5312 19.2012 11.4375 19.6125 11.5062 20C11.4375 20.3875 11.5312 20.7988 11.8312 21.0988L18.9025 28.17C19.3912 28.6588 20.1825 28.6588 20.67 28.17C21.1588 27.6812 21.1588 26.89 20.67 26.4025L15.5175 21.25H28.75C29.44 21.25 30 20.69 30 20C30 19.31 29.44 18.75 28.75 18.75Z" fill="#107651"/>
                     </svg>
                  </button>
               </div>

               <nav>
                  { navigation.map( item => {

                     if ( item.allowed_role && !item.allowed_role.includes( user.role?.name ))
                        return null;

                     return "group" in item
                        ? <span key={ item.group }> { item.group } </span>
                        : item.path ? (
                           <Fragment key={ item.path }> 
                              <NavLink
                                 key={ item.path }
                                 to={ item.path }
                                 className={({ isActive }) => isActive ? "active" : "" }
                              >
                                 { item.svg }
                                 <span> { item.title } </span>

                                 { item.path === Paths.Documents.Start && 
                                    <button onClick={ e => {
                                       e.preventDefault();
                                       e.stopPropagation();

                                       setOpenSubmenu( o => !o );
                                    }}>
                                       <AngleDownSvg style={{ transform: `rotate(${ open_submenu ? "180deg" : "0" })`}}/>
                                    </button>
                                 }
                              </NavLink>
                              
                              { open_submenu && item.path === Paths.Documents.Start && 
                                 <div className="nav-submenu">
                                    { !!doc_types && doc_types.map(({ id, name }) => (
                                       <NavLink 
                                          key={ id }
                                          to={ Paths.Documents.List( id )}   
                                       >
                                          <span> { name } </span>
                                       </NavLink>
                                    ))}
                                 </div>
                              }
                           </Fragment>
                        ) : (
                           <a 
                              href="#" 
                              key={ item.title }
                              onClick={ e => {
                                 e.preventDefault();

                                 item.title === "Wyloguj się" && logOut();

                                 item.title === "Ustawienia profilu" && showProfile();
                              }}   
                           >
                              { item.svg }
                              <span> { item.title } </span>
                           </a>
                        )
                  })}
               </nav>
            </div>
         </div>
      </div>
   )
}